import React, {useEffect, useState} from 'react';
import Box from "@material-ui/core/Box";
import Graph from "./Graph";
import {Paper, Typography} from "@material-ui/core";
import ApplicationResourceWiseSpend from "./ApplicationResourceWiseSpend";
import service from "../../../../service/service";
import {PaperProgress} from "../../../ProgressCircle/ProgressCircle";
import {accountLengthAdjust} from "../../../../helper/generalFunctions";
import {useOrganization} from "../../../../hooks/useOrganization";

//dummy

import {accountTrendApplication} from '../../../../assets/finthesys/accountTrend'

export default function ApplicationSpend({data}) {
    const {organization: masterAccountId} = useOrganization()
    const [graphData, setGraphData] = useState([])
    const [ready, setReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const fetchData = async () => {
        try {
            setReady(false)
            setLoading(true)
            console.log(masterAccountId)
            const params = {
                "master_account_id": masterAccountId,
                "account_id": accountLengthAdjust(data.accountId).toString(),
                "date": data.date,
                "report_type": "application"
            }
            const {data: {graphData}} = await service.accountTrend().getAccountTrendDaily(params);
            setGraphData(graphData)
            setReady(true)
        } catch (e) {

        } finally {
            setLoading(false)
        }
    }

    const fetchDummyData = async () => {
        try {
            setLoading(true)
            setReady(false)
            const {graphData} = accountTrendApplication
            setGraphData(graphData)
            setReady(true)

        } catch (e) {

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (masterAccountId !== 'no org') {
            fetchDummyData().then(() => {
            })
        }
    }, [masterAccountId])

    const handleDialogOpen = (e) => {
        setSelectedData({applicationName: e, accountId: data.accountId, date: data.date})
        setDialogOpen(true);
    }

    return (
        <Paper variant={'outlined'}>
            {dialogOpen && <ApplicationResourceWiseSpend open={dialogOpen} onChange={(e) => setDialogOpen(false)}
                                                         data={selectedData}/>}
            <Box mt={2} ml={2} mr={2}>
                <Typography variant={'h6'}>Application Spend</Typography>
                <Box mt={-1} mb={2}>
                    {
                        ready && <Graph graphData={graphData} onClick={handleDialogOpen}/>
                    }
                    {loading && <Box mt={2} mb={2}><PaperProgress/></Box>}
                </Box>
            </Box>
        </Paper>
    )
}